import type { DraftInput } from '../../../../shared/drafts';

function createQuestion(level: number): DraftInput['questions'][number] {
  return {
    prompt: `${level}. yarış sorusu`,
    wagonStyle: 'wide',
    levels: [level],
    timeLimitSeconds: null,
    choices: [
      { text: 'Doğru cevap', isCorrect: true },
      { text: 'Yanlış cevap 1', isCorrect: false },
      { text: 'Yanlış cevap 2', isCorrect: false },
    ],
  };
}

export function createTurboDuelDraft(): DraftInput {
  return {
    title: 'Yeni Turbo Düellosu',
    templateKey: 'turbo-duel',
    levelMode: 'manual',
    maxLevels: 1,
    trackTime: true,
    timingMode: 'none',
    questions: [createQuestion(1)],
  };
}

export function resizeTurboDuelDraft(draft: DraftInput, maxLevels: number): DraftInput {
  const safeLevels = Math.max(1, Math.min(10, Math.trunc(maxLevels)));
  const questions = Array.from({ length: safeLevels }, (_, index) => {
    const level = index + 1;
    const existing = draft.questions.find((question) => question.levels[0] === level);
    return { ...(existing ?? createQuestion(level)), levels: [level] };
  });
  return {
    ...draft,
    templateKey: 'turbo-duel',
    levelMode: 'manual',
    maxLevels: safeLevels,
    trackTime: true,
    bridgeMode: undefined,
    timingMode: draft.timingMode ?? 'none',
    questions,
  };
}
